// BCP 47 locale code format
export const LANGUAGE_OPTIONS = [
  { value: 'en-US', label: 'English, United States (en-US)' },
  { value: 'en-GB', label: 'English, United Kingdom (en-GB)' },
  { value: 'it-IT', label: 'Italian (it-IT)' },
  { value: 'fr-FR', label: 'French (fr-FR)' },
  { value: 'fr-CA', label: 'French, Canada (fr-CA)' },
  { value: 'es-ES', label: 'Spanish (es-ES)' },
  { value: 'es-MX', label: 'Spanish, Mexico (es-MX)' },
  { value: 'de-DE', label: 'Germany (de-DE)' },
  { value: 'pl-PL', label: 'Poland (pl-PL)' },
  { value: 'nl-NL', label: 'Netherlands (nl-NL)' },
  { value: 'nl-BE', label: 'Belgium Dutch (nl-BE)' },
  { value: 'fr-BE', label: 'Belgium French (fr-BE)' },
  { value: 'sv-SE', label: 'Sweden (sv-SE)' },
  { value: 'de-AT', label: 'Austria (de-AT)' },
  { value: 'pt-PT', label: 'Portugal (pt-PT)' },
  { value: 'pt-BR', label: 'Portugal (pt-BR)' },
  { value: 'fr-CH', label: 'Switzerland (fr-CH)' },
  { value: 'it-CH', label: 'Switzerland (it-CH)' },
  { value: 'de-CH', label: 'Switzerland (de-CH)' },
];
